import { render } from "./admin-charts.vue?vue&type=template&id=0bbe857c"
import script from "./admin-charts.vue?vue&type=script&lang=js"
export * from "./admin-charts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__